import { Navigate, Route, Routes } from 'react-router-dom'
import SignupPage from './SignupPage'
import { CheckEmailScreen, ExpiredScreen, InvalidLinkScreen } from './SignupScreens'

// The public, unauthenticated signup tree (E4 F4-1). Mounted in index.tsx OUTSIDE the MSAL provider /
// RequestInterceptor so it never triggers a sign-in redirect. Self-contained routing under /signup.
const SignupApp = () => (
  <Routes>
    <Route path='/signup' element={<SignupPage />} />
    <Route path='/signup/check-email' element={<CheckEmailScreen />} />
    <Route path='/signup/expired' element={<ExpiredScreen />} />
    <Route path='/signup/invalid-link' element={<InvalidLinkScreen />} />
    <Route path='*' element={<Navigate to='/signup' replace />} />
  </Routes>
)

export default SignupApp
